// Catalogo fixo das permissoes administrativas granulares - espelho de
// backend/src/constants/adminPermissions.ts (mesmas chaves, mesma ordem).
// Usado pra montar os checkboxes em UserModal e pra checar visibilidade
// via hasPermission(user, key) em MainListItems/Dashboard.
export const ADMIN_PERMISSIONS = [
  { key: "menu:campaigns", label: "Campanhas", category: "Menu" },
  { key: "menu:flowbuilder", label: "Flowbuilder", category: "Menu" },
  { key: "menu:messages-api", label: "API", category: "Menu" },
  { key: "menu:users", label: "Usuários", category: "Menu" },
  { key: "menu:faq-moderation", label: "Base de Conhecimento", category: "Menu" },
  { key: "menu:ai-costs", label: "Custos de IA", category: "Menu" },
  { key: "menu:sefaz-monitor", label: "Monitor SEFAZ", category: "Menu" },
  { key: "menu:queues", label: "Filas & Chatbot", category: "Menu" },
  { key: "menu:prompts", label: "Talk.Ai", category: "Menu" },
  { key: "menu:queue-integration", label: "Integrações", category: "Menu" },
  { key: "menu:files", label: "Lista de arquivos", category: "Menu" },
  { key: "menu:financeiro", label: "Financeiro", category: "Menu" },
  { key: "menu:settings", label: "Configurações", category: "Menu" },
  { key: "menu:commercial", label: "Comercial", category: "Menu" },
  { key: "menu:on-call", label: "Sobreaviso", category: "Menu" },
  { key: "oncall:calendar-view", label: "Sobreaviso — somente ver calendário (sem editar/gerar escala)", category: "Menu" },
  { key: "menu:boards", label: "Kanban", category: "Menu" },
  { key: "menu:clientes-criticos", label: "Clientes Críticos", category: "Menu" },
  { key: "menu:tasks", label: "Tarefas", category: "Menu" },
  { key: "menu:schedules", label: "Agendamentos", category: "Menu" },
  { key: "dashboard:tab:overview", label: "Dashboard — Visão Geral", category: "Dashboard" },
  { key: "dashboard:tab:quality", label: "Dashboard — Qualidade & Carga", category: "Dashboard" },
  { key: "dashboard:tab:detailed", label: "Dashboard — Relatório Detalhado", category: "Dashboard" }
];
